import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './monitoring/sentry';

// Start error monitoring (only active when a Sentry DSN is configured).
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
